export const DATA_REFRESH_NOTIFICATION_TIP =
    `Receive emails when the data refresh is complete, so you know it's time to run your Byzzer reports. Set the cadence that best aligns to your reporting needs.`;

export const PLATFORM_NOTIFICATION_TIP =
    `By opting into these notifications, you will receive emails with information about platform updates. These are the same notifications that currently post to your Homepage and Notifications Menu, delivered to your inbox.`;

export const DEFAULT_FOCUSKPI = 'Dollar Sales';